import { render } from "./ClientChartToReportPageType.vue?vue&type=template&id=b5946802"
import script from "./ClientChartToReportPageType.vue?vue&type=script&lang=js"
export * from "./ClientChartToReportPageType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__